import { CREATE_AWARD, REMOVE_AWARD } from "./actions";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../../../utils/localStorage";

export const awards = (state=loadFromLocalStorage(CREATE_AWARD, []), action) =>{
    const {type, payload} = action;

    switch(type){
        case CREATE_AWARD:{
            const {award} = payload;
            const newAward = {
                award,
            };
            const updatedState = state.concat(newAward);
            saveToLocalStorage(CREATE_AWARD, updatedState);
            return state.concat(updatedState);
        }
        case REMOVE_AWARD: {
            const {award} = payload;
            const updatedState = state.filter(obj => obj.award !== award);
            saveToLocalStorage(CREATE_AWARD, updatedState);
            return updatedState;
        }
        default: 
            return state;
    }
}